var exports = {
  "h": "xa15a2ab7--b9d5cd--input",
};

module.exports = exports;
